import {DomainPath} from '@twpub/core/models';

export const formatDomainPath = (path: DomainPath) => {
  return path.path.map(dom => dom.name).join(' > ');
}

export const formatDomainPaths = (paths?: DomainPath[]) => {
  return paths?.map(path => formatDomainPath(path)).join(' | ') || '';
}
